const CalendarClass = `class Calendar {

    constructor(el, options = {}) {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        const DateTime = luxon.DateTime;
        const Local = DateTime.local();
        const calendar = document.querySelector(el);
        this.calendar = calendar;
        this.DateTime = DateTime;
        this.Local = Local;
        this.months = months;
        this.days = days;
        this.options = options;
        this.tableBody;
        this.constructCalendar(Local);
    }

    constructCalendar(date) {
        this.calendar.innerHTML = '';
        date === undefined ? date = this.Local : date;
        this._checkOptions4JumpToDateFieldAndReturnHTMLElement(date);
        this._setSelectedCellsOfTheCalendarTable(this.options.SelectedDates);
    }

    // returns an array with years based on current year
    createArrayOfYearsFromCurrentYear(yearsBackward, yearsForward) {
        let yBack = [];
        let yFow = [];
        let result = [];
        for (var i = 1; i <= yearsForward; i++) {
            yFow.push(this.Local.year + i);
        }
        for (var i = yearsBackward; i >= 0; i--) {
            yBack.push(this.Local.year - i);
        }
        return result = result.concat(yBack, yFow);
    }

    // PRIVATE METHODS

    _createCalendarBody(date) {
        let calendarWrapper = document.createElement('div');
        calendarWrapper.className = 'calendar-wrapper';
        if (this.options.CalendarCSSClass) {
            calendarWrapper.className = 'calendar-wrapper ' + this.options.CalendarCSSClass;
        }

        let firstDayOfTheMonth = date.startOf('month').weekday;
        let daysInMonth = date.daysInMonth;

        let titleContainer = document.createElement('div');
        let titleInner = document.createElement('span');
        titleContainer.className = 'calendar-title-container text lg', titleInner.innerHTML = date.monthShort + ' ' + date.year;
        let prev = document.createElement('span');
        let next = document.createElement('span');
        prev.innerHTML = '&#60;', next.innerHTML = '&#62;', prev.className = 'arrow', next.className = 'arrow';

        // ONCLICK FOR PREVOIUS AND NEXT BUTTONS
        next.onclick = () => {
            this._nextMonth(date)
        }

        prev.onclick = () => {
            this._prevMonth(date)
        }

        titleContainer.appendChild(prev), titleContainer.appendChild(titleInner), titleContainer.appendChild(next);

        let table = document.createElement('table');
        let thead = document.createElement('thead');
        let tbody = document.createElement('tbody');
        this.tableBody = tbody;
        let trHead = document.createElement('tr');
        for (let i = 0; i < this.days.length; i++) {
            let th = document.createElement('th');
            th.innerHTML = this.days[i], trHead.appendChild(th);
        }
        thead.appendChild(trHead), table.appendChild(thead), table.appendChild(tbody), calendarWrapper.appendChild(titleContainer), calendarWrapper.appendChild(table);

        // create the tbody
        // rows loop
        let count = 1;
        for (let i = 0; i < 6; i++) {
            let trBody = document.createElement('tr');
            // rows elements loop
            for (let j = 0; j < 7; j++) {
                if (i === 0 && j < firstDayOfTheMonth - 1) { // create an empty cell if there is no day
                    let tdBody = document.createElement('td');
                    trBody.appendChild(tdBody);
                } else if (count > daysInMonth) { // count becomes bigger than daysInMonth break loop
                    break;
                } else {
                    let tdBody = document.createElement('td');
                    tdBody.className = 'cell', tdBody.innerHTML = count;
                    if (j === 5 || j === 6) {
                        tdBody.className = 'cell-sat-sun';
                    }
                    if (count === this.Local.day && date.year === this.Local.year && date.month === this.Local.month) {
                        tdBody.className = 'cell-today';
                    }
                    tdBody.setAttribute('title', this.Local.set({
                        year: date.year,
                        month: date.month,
                        day: count
                    }).toFormat('yyyy-LL-dd'));
                    tdBody.addEventListener('click', function () {
                        captureCalendarDate(tdBody.title)
                    })
                    trBody.appendChild(tdBody), count++;
                }
            }
            tbody.appendChild(trBody);
        }
        return calendarWrapper;
    }

    _nextMonth(date) {
        this.constructCalendar(date.plus({
            month: 1
        }))
    }

    _prevMonth(date) {
        this.constructCalendar(date.plus({
            month: -1
        }))
    }

    _jumpToDate(date) {
        this.calendar.innerHTML = '';
        date === undefined ? date = this.Local : date;
        this._checkOptions4JumpToDateFieldAndReturnHTMLElement(date);
        this._setSelectedCellsOfTheCalendarTable(this.options.SelectedDates);
    }

    _createJumpToDateFields(yearsBackward, yearsForward, date) {
        const jumpToDateContainer = document.createElement('div');
        jumpToDateContainer.className = 'jump-to-date-container';
        const yearsInSelect = this.createArrayOfYearsFromCurrentYear(yearsBackward, yearsForward);
        // month select
        let monthSelect = document.createElement('select');
        for (let i = 0; i < this.months.length; i++) {
            let option4Month = document.createElement('option');
            option4Month.value = i + 1, option4Month.innerHTML = this.months[i];
            if (this.months[i] == date.monthShort) {
                option4Month.selected = 'selected';
            }
            monthSelect.appendChild(option4Month);
        }
        // year select
        let yearSelect = document.createElement('select');
        for (let i = 0; i < yearsInSelect.length; i++) {
            let option4Year = document.createElement('option');
            option4Year.value = yearsInSelect[i], option4Year.innerHTML = yearsInSelect[i];
            if (yearsInSelect[i] === date.year) {
                option4Year.selected = 'selected';
            }
            yearSelect.appendChild(option4Year);
        }
        yearSelect.onchange = () => {
            this._jumpToDate(this.Local.set({
                year: yearSelect.value,
                month: monthSelect.value,
                day: 1
            }));
        };
        monthSelect.onchange = () => {
            this._jumpToDate(this.Local.set({
                year: yearSelect.value,
                month: monthSelect.value,
                day: 1
            }));
        };
        jumpToDateContainer.appendChild(monthSelect), jumpToDateContainer.appendChild(yearSelect);
        return jumpToDateContainer;
    }

    _checkOptions4JumpToDateFieldAndReturnHTMLElement(date) {
        let calendarBody = this._createCalendarBody(date);
        if (this.options && this.options.JumpToDateFields) {
            let yBack = 10;
            let yFow = 10;

            if (this.options.JumpToDateFields.yearsBack) {
                yBack = this.options.JumpToDateFields.yearsBack;
            }
            if (this.options.JumpToDateFields.yearsForward) {
                yFow = this.options.JumpToDateFields.yearsForward;
            }
            if (this.options.JumpToDateFields.fieldPosition) {
                if (this.options.JumpToDateFields.fieldPosition === 'after-title') {
                    calendarBody.insertBefore(this._createJumpToDateFields(yBack, yFow, date), calendarBody.childNodes[1]);
                } else if (this.options.JumpToDateFields.fieldPosition === 'bottom') {
                    calendarBody.insertBefore(this._createJumpToDateFields(yBack, yFow, date), calendarBody.childNodes[2]);
                } else if (this.options.JumpToDateFields.fieldPosition === 'before-title') {
                    calendarBody.insertBefore(this._createJumpToDateFields(yBack, yFow, date), calendarBody.childNodes[0]);
                }
            }
        }
        this.calendar.appendChild(calendarBody)
    }

    _setSelectedCellsOfTheCalendarTable(data = {}) {
        if (data.length > 0) {
            for (let b = 0; b < this.tableBody.childNodes.length; b++) {
                for (let c = 0; c < this.tableBody.childNodes[b].childNodes.length; c++) {
                    data.forEach((el) => {
                        let dateReturned = this._returnDateFromTitleAsObjectFormatted(this.tableBody.childNodes[b].childNodes[c].title);
                        if (el.day == dateReturned.day && el.month == dateReturned.month && el.year == dateReturned.year) {
                            if (this.tableBody.childNodes[b].childNodes[c].classList.contains('cell-today')) {
                                this.tableBody.childNodes[b].childNodes[c].className = 'cell-selected today';
                            } else {
                                this.tableBody.childNodes[b].childNodes[c].className = 'cell-selected';
                            }
                        }
                    });
                }
            }
        }
    }

    _returnDateFromTitleAsObjectFormatted(date) {
        let dateArray = date.split('-');
        let result = {
            day: dateArray[2],
            month: dateArray[1],
            year: dateArray[0]
        }
        return result;
    }

    _remove(element) {
        const e = document.querySelector(element)
        e.innerHTML = ''
    }

}`

export default CalendarClass